<template>
  <aside 
    :class="['mcart',{'mcart--open': isCartOpen}]"
    aria-modal="true"
    role="modal"
    tabindex="0"
  >
  <CartBody
    :cartData="data"
    :isCartOpen="isCartOpen"
    @on-toggle="toggle"
  />
  </aside>
</template>

<script setup>
  import { ref, onBeforeMount } from 'vue';
  import CartBody from './components/cart-body.vue'

  var isCartOpen = ref(false);
  const overlay = new window.Overlay();

  const props = defineProps({
    data: {
      type: Object,
      default: () => ({})
    }
  })

  onBeforeMount(async () => {
    // Setting window function for toggle
    window.openCart = toggle;
  })

  const body = document.body;
  let scrollPosition = 0;

  function lockScroll() {
    scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    body.style.position = 'absolute';
    body.style.top = `-${scrollPosition}px`;
    body.style.width = '100%';
    body.style.overflow = 'hidden';
  }

  function unlockScroll() {
    body.style.position = '';
    body.style.top = '';
    body.style.width = '';
    body.style.overflow = '';
    window.scrollTo(0, scrollPosition);
  }

  function toggle(_open) {
    const op = typeof _open === "boolean" ? _open : !isCartOpen.value;
    isCartOpen.value = op;
    let bodyStyle = document.body.style;

    if (op){
      overlay.show();
      lockScroll();
      //bodyStyle.overflow = 'hidden'
    } else{
      unlockScroll();
      overlay.hide();
      //bodyStyle.overflow = 'auto'
    } 
  }

  overlay.on('cancel', () => {
    unlockScroll();
    toggle(false);
  });
</script>